import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbInfoTriangle } from "react-icons/tb";

import CommonAlert from "@/components/CommonAlert";
import useBulkUnassignPassengers from "@/providers/hooks/useBulkUnassignPassengers";
import { useTrackingActions, useTrackingShowBulkUnassignDialog } from "@/stores/use-tracking-table";

function TrackingUnassignTaskDialog() {
    const { t } = useTranslation();
    const showBulkCancelDialog = useTrackingShowBulkUnassignDialog();
    const { handleBulkUnassignPassengers, unassignPending } = useBulkUnassignPassengers();

    const { updateShowBulkUnassignDialog } = useTrackingActions();
    const handleConfirm = async () => {
        if (unassignPending || !showBulkCancelDialog) return;
        await handleBulkUnassignPassengers(showBulkCancelDialog.ids);
        handleClose();
    };

    const handleClose = () => {
        updateShowBulkUnassignDialog(null);
    };

    return (
        <CommonAlert
            open={!!showBulkCancelDialog}
            loading={unassignPending}
            description="confirmations.bulkTaskUnassign"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                count: showBulkCancelDialog?.ids.length || 1,
            }}
        >
            {showBulkCancelDialog && showBulkCancelDialog.totalPassengers === showBulkCancelDialog.ids.length && (
                <Alert icon={<TbInfoTriangle />} className="mt-2" severity="error">
                    {t("infos.taskWillRemoved")}
                </Alert>
            )}
        </CommonAlert>
    );
}

export default TrackingUnassignTaskDialog;
